import fetchApi from './fetch';

export function getPublicPlans() {
  return fetchApi('/plans', 'POST');
}